export enum PageModeEnum {
    READ_ONLY = 0,
    CREATE = 1,
    EDIT = 2
}